export default __webpack_public_path__ + "static/media/eBay.4dd93b23.svg";